export default __webpack_public_path__ + "static/media/me_inactive.d5e46dca.svg";